import './App.css';
import { Home } from './modules/Home';

function App() {
  return (
    <Home/>
  );
}

export default App;
